exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs5-estimated-earns-card[data-v-673b5ad8]{font:inherit;padding:2em;min-height:13.4em;border:1px solid #c9e4ff;background-color:#fff;border-radius:.8em;text-align:center}.fs5-estimated-earns-card .fs5-earns-card-title[data-v-673b5ad8]{font:inherit;color:#6a6a68;font-size:1.6em;line-height:1.2;font-weight:700;padding-bottom:.625em}.fs5-estimated-earns-card .fs5-earns-card-value[data-v-673b5ad8]{font:inherit;color:#2c6bfe;font-size:3.6em;line-height:1.2;font-weight:800}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-673b5ad8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v5/tools/card/EstimatedEarnsCard.vue
// module id = mvwv
// module chunks = 0